export function FormBuilderAlerts({
  validationErrors,
  saveError,
  saveFailed,
}: {
  validationErrors: string[];
  saveError: string | null;
  saveFailed: boolean;
}) {
  if (validationErrors.length === 0 && !saveError) return null;

  return (
    <div
      id="form-builder-alerts"
      className="rounded-lg border border-red-300 bg-red-50 px-4 py-3 shadow-sm"
      role="alert"
      aria-live="assertive"
    >
      <p className="font-onest text-sm font-semibold text-red-800">
        {saveFailed ? "Форма не сохранена" : "Не удалось выполнить действие"}
      </p>
      {saveFailed ? (
        <p className="mt-1 font-onest text-sm text-red-700">
          Изменения остались в редакторе. Исправьте ошибку и нажмите «Сохранить»
          ещё раз.
        </p>
      ) : null}
      {validationErrors.length > 0 ? (
        <div className="mt-2">
          <ul className="list-disc space-y-1 pl-5 font-onest text-sm text-red-700">
            {validationErrors.map((message) => (
              <li key={message}>{message}</li>
            ))}
          </ul>
        </div>
      ) : null}

      {saveError ? (
        <p className="mt-2 font-onest text-sm text-red-700">{saveError}</p>
      ) : null}
    </div>
  );
}
